import { useMutation } from 'react-query'
import { type TaskPersistence } from '../../../../types/persistence/task-persistence'
import { api } from '../../../api'

const updateTask = async (taskId: number, data: TaskPersistence) => {
  const response = await api.put(`/tasks/${taskId}`, data)
  return response.data
}

export const useTaskUpdateMutation = () => {
  return useMutation({
    mutationFn ({ taskId, data }: { taskId: number, data: TaskPersistence }) {
      return updateTask(taskId, data)
    }
  })
}
